'use client'

import * as React from 'react'

import { Button } from '../../components/button'

interface CtaBlockFields {
  blockType: 'cta'
  text: string
  link: string
}

interface CtaBlockProps {
  fields: CtaBlockFields
}

export function CtaBlock({ fields }: CtaBlockProps) {
  return (
    <div className='ui:my-6 ui:flex ui:justify-center'>
      <Button asChild>
        <a href={fields.link} target='_blank' rel='noopener noreferrer' className='ui:shadow-lg ui:hover:shadow-xl'>
          {fields.text}
        </a>
      </Button>
    </div>
  )
}
